'use client';

import { useState } from 'react';
import { useTranslation } from 'next-i18next';

interface CandidateJobSearchSalaryProps {
  onChange: (salary: number) => void;
  initialSalary?: number;
}

/**
 * @description Salary input (net, EUR) for the candidate job search form.
 * Accepts a single positive integer.
 */
export const CandidateJobSearchSalary = ({ onChange, initialSalary }: CandidateJobSearchSalaryProps) => {
  const { t } = useTranslation('common');

  const [displayValue, setDisplayValue] = useState(initialSalary ? String(initialSalary) : '');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digitsOnly = e.target.value.replace(/\D/g, '');
    setDisplayValue(digitsOnly);
    onChange(digitsOnly ? Number(digitsOnly) : 0);
  };

  return (
    <div className="relative">
      <input
        type="text"
        inputMode="numeric"
        pattern="\d*"
        value={displayValue}
        onChange={handleChange}
        placeholder={t('salary.amount.placeholder')}
        className="h-12 w-full rounded-2xl border border-input/65 bg-surface px-4 pr-14 text-base font-medium text-ink placeholder:text-ink-light focus:border-secondary focus:outline-none focus:ring-2 focus:ring-secondary/20 md:text-sm"
      />

      <div className="pointer-events-none absolute right-3 top-0 flex h-12 items-center text-ink-medium">
        <span className="text-sm font-semibold tracking-tight">EUR</span>
      </div>
    </div>
  );
};
